import React from 'react'
import { Row, Col } from '../LayoutSystem'
import { IRowProps } from '../LayoutSystem/Row'
import { TContainer } from '../LayoutSystem/types'

export interface IProps extends IRowProps {
    full?: boolean
    noOffset?: boolean
    container?: TContainer
}

const Container = React.forwardRef<HTMLDivElement, IProps>(
    ({ children, full = false, noOffset = false, container, ...props }, ref) => {
        const size = full ? 'full' : 'vnw'
        const xsOffset = noOffset ? 0 : 8
        const smOffset = noOffset ? 0 : 16
        return (
            <Row
                ref={ref}
                container={{
                    responsive: {
                        xs: {
                            size,
                            offset: xsOffset
                        },
                        sm: {
                            size,
                            offset: smOffset
                        }
                    }
                }}
                {...props}
            >
                <Col>{children}</Col>
            </Row>
        )
    }
)

export default Container
